var DialogLocationsModule = /** @class */ (function () {
    function DialogLocationsModule() {
    }
    return DialogLocationsModule;
}());
export { DialogLocationsModule };
